import Events from 'builder/components/PremierVirtual/Events'

export const MyEventsView = () => {
  return <Events />
}
